<template>
  <BaseModal
    :value="true"
    :max-width="700"
    is-complex
    persistent
    :modal-title="$t('anonymous_confirmation.title')"
  >
    <template #modal>
      <div class="confirmation_content">
        <div
          class="alert_text"
          v-text="
            $t('anonymous_confirmation.alert', {
              name: courseName,
            })
          "
        />
        <div class="text" v-text="$t('anonymous_confirmation.message_1')" />
        <div class="text" v-text="$t('anonymous_confirmation.message_2')" />
      </div>
    </template>
    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="$emit('confirm', false)"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton
        color="primary"
        type="primary"
        @click="$emit('confirm', true)"
      >
        {{ $t("utils.confirm") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
export default {
  name: "CourseConfirmChangeAnonymousStatus",
  props: {
    courseName: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.confirmation_content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  .alert_text {
    color: #ff5267;
  }
  .text {
    color: #707080;
  }
}
</style>
